export default function getGlobalAlert(description,status,listToast, setListToast, typeAlertModal = false, titleModal, setListModal, listModal) {

    if(!description || !status) {
        return;
    }

    let title;
    let bgColor;
    let icon;

    switch(status) {
        case 'success':
            title = "Éxito";
            bgColor = '#5cb85c';
            icon = "check";
        break;
        case 'danger':
            title = "Peligro";
            bgColor = '#d9534f';
            icon = "attention";
        break;
        case 'info':
            title = "Información";
            bgColor = '#5bc0de';
            icon = "search";
        break;
        case 'warning':
            title = "Advertencia";
            bgColor = '#f0ad4e';
            icon = "attention";
        break;
        default:
            title = status;
            bgColor = 'gray';
        break;
    }

    if(typeAlertModal){
        setListModal([...listModal, {
            id: Number(listModal?.length),
            title: titleModal,
            description: description?.trim(),
            status:status
        }]);
    } else {
        setListToast([...listToast,{
            id: Number(listToast?.length),
            title: title,
            description: description?.trim(),
            backgroundColor: bgColor,
            icon: icon
        }]);
    }

}